import { MusicStructureAnnotationBlock } from "./MusicStructureAnnotationBlock.js";
import { ChordTrack } from "./ChordTrack.js";

export class MetadataTracks {
    constructor(jsonStructure) {
        /**
         * @type {Array<MusicStructureAnnotationBlock>}
         */
        this.music_structure_track = [];

        for (const annotationBlock of jsonStructure.music_structure_track) {
            this.music_structure_track.push(new MusicStructureAnnotationBlock(annotationBlock));
        }

        // print out os debug
        // console.log("OSDEBUG Music Structure Track:", this.music_structure_track);

        /**
         * @type {ChordTrack}
         */
        this.chord_track = new ChordTrack(jsonStructure.chord_track);
    }
}
